/**
 * @file billingPaths.ts
 * @brief Deep links into a personal user's Billing area (`/app/billing/*`).
 *
 * @details
 * Emails, notifications and error toasts link straight to one screen, e.g.
 * `/app/billing/cards` after a failed payment. Keep the section names stable:
 * they are URLs other systems store.
 *
 * @author DES
 * @date 17-10-2026
 */

export const BILLING_SECTIONS = ["plan", "usage", "cards", "invoices"] as const;
export type BillingSection = (typeof BILLING_SECTIONS)[number];

export const BILLING_BASE = "/app/billing";

export function billingPath(section: BillingSection): string {
  return `${BILLING_BASE}/${section}`;
}

export function isBillingSection(value: string | undefined): value is BillingSection {
  return !!value && (BILLING_SECTIONS as readonly string[]).includes(value);
}
